import formatter from './formatter';
import getColor from './getColor';
export const plugin = {
  seriesType: 'pie',
  colorProcessor: getColor,
  seriesFormatter: formatter
};